module.exports = __webpack_public_path__ + "static/img/zhong23.0ed2710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong23.png
// module id = 65De
// module chunks = 16